import React, {Component} from 'react';
import Chart from "react-google-charts";

class GraficResultatsCandidatura extends Component {	
    
  //Rep props resultats i partits amb els resultats de les diferents candidatures
  //Només farem les operacions si rebem dades

  state = {
    valorsGrafic:null
  }

  carregaDadesGrafic() {
    if (this.props.resultats&&this.props.partits) {
      //1. contem les columnes que farem, el màxim serà 7.
      var numColumnes = this.props.resultats.length
      if (numColumnes>7) numColumnes=7; //limit màxim

      //2. preparem array amb els valors
      var arraySortida = []
      var i = 0

      while (i<numColumnes) {
        var percentatge = this.props.resultats[i].vots_per
        //Busquem si la candidatura està a la BD de partits
        var sigles = this.props.resultats[i].sigles;
        var color = "#DDDDDD";

        this.props.partits.forEach(element => {
            if (element.codi_generalitat === this.props.resultats[i].codi)  {
                sigles = element.sigles;
                if (element.color) color = element.color; //Mirar que el color no sigui null
            }
        });

        arraySortida.push({
          sigles:sigles,
          color:color,
          percentatge:percentatge
        })
        i++;
      }

    } 

    this.setState({valorsGrafic:arraySortida});
  }
  
  componentDidUpdate(prevProps) { //Si es canvia la url que rebem a traves de match, es torna a cridar al backend.
    if (this.props.resultats!==prevProps.resultats) {
      this.carregaDadesGrafic();
      
        // this.trobaResultats();
    }
  }

  componentDidMount() {
    this.carregaDadesGrafic();
  }
  
  
  render() {

    //Genera array grafic
    if (this.props.resultats&&this.props.partits&&this.state.valorsGrafic) {
      var arrayGrafic=[ 
        [
          'Candidatura',
          'Percentatge',
          { role: 'style' },
        ]
       ]

      this.state.valorsGrafic.forEach(valor => {
        arrayGrafic.push(
          [valor.sigles, valor.percentatge, 'color: ' + valor.color]
        )
      });
    }


    

     return (

      <div>
        {this.props.resultats&&this.props.partits&&this.state.valorsGrafic &&
            <Chart
                width={'100%'}
                height={300}
                chartType="ColumnChart"
                loader={<div>Carregant gràfic</div>}
                data={arrayGrafic}
                options={{
                title: 'Candidatures més votades - Percentatge de vots',
                chartArea: { width: '90%' },            
                legend: { position: 'none' },
                }}
                legendToggle
            />
          }
      </div>
      );
    }
  }

  export default GraficResultatsCandidatura;